<div class="mb-5">
	<h1 class="h3 m-4">{{'utilization.charger_fleet_utilization_score' | translate}} <app-help-tooltip [field]="'chargLinkDevice.site_fleet_utilization_score'"></app-help-tooltip></h1>
	<app-score-chart *ngIf="data" [data]="data" [hasWorkingDaysFilter]="true"></app-score-chart>
</div>
